import { render, staticRenderFns } from "./product-variant-list-wrapper.vue?vue&type=template&id=f9e2d28c&"
import script from "./product-variant-list-wrapper.vue?vue&type=script&lang=js&"
export * from "./product-variant-list-wrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports